import { ScrollContainer } from '@bloomfieldrobotics/canopy';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { MenuPaper } from '../../commonUI/Menu/MenuPaper';
import UploadSortOrderDropdown from './components/UploadSortOrderDropdown';
import { UploadSummaryList } from './components/UploadSummaryList';
export const UploadsSection = () => {
  const { t } = useTranslation();

  return (
    <MenuPaper
      sx={{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          height: '100%',
          width: '100%',
          p: '1rem',
          gap: '1rem',
        }}
      >
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
          }}
        >
          {t('Uploading blocks')}
        </Typography>
        <UploadSortOrderDropdown />
        <ScrollContainer>
          <UploadSummaryList />
        </ScrollContainer>
      </Stack>
    </MenuPaper>
  );
};
